if (jQuery('#testimonialSlider').length) {
  jQuery('#testimonialSlider').slick({
    slidesToShow: 2.3,
    slidesToScroll: 1,
    arrows: true,
    centerMode: false,
    focusOnSelect: true,
    prevArrow:jQuery('.testimonial-slider-prev'),
    nextArrow:jQuery('.testimonial-slider-next'),
    infinite: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 1.3,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });
  
  var height = 200;
  jQuery(document).ready(function() {
    jQuery(window).on('resize load', function() {
      jQuery('.testimonial-slider .slick-slide .card').each(function() {
        if (jQuery(this).height() > height) {
          height = jQuery(this).height();
        }
      });
  
      var size = height + 80;
  
      jQuery('.testimonial-slider .slick-slide .card').css('height', size+'px');
    });
  });
}
